<template>
    <themed-modal
        name="new-proposal-expense"
        title="Add Expense"
        size="md"
        :show-footer="true"
        @opened="handleModalOpened"
        @closed="resetForm">
        
        <themed-form
            v-if="isReady"
            :fields="formFields"
            v-model="expense"
            :errors="errors"
            layout="grid"
            :columns="3"
            :loading="loading">
            
            <template #submit>
                <!-- Footer buttons handled in modal footer slot -->
            </template>
        </themed-form>

        <template #footer>
            <themed-button variant="secondary" @click="$modal.hide('new-proposal-expense')">
                Close
            </themed-button>
            <themed-button variant="default" @click="createExpense" :disabled="loading">
                <span v-if="loading">Adding...</span>
                <span v-else>Add Expense</span>
            </themed-button>
        </template>
    </themed-modal>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import ThemedModal from '../ThemedModal.vue';
    import ThemedForm from '../form/ThemedForm.vue';
    
    export default {
        name: 'NewProposalExpenseV1',

        components: {
            ThemedModal,
            ThemedForm
        },

        data() {
            return { 
                expenseTypes: {},
                expense: {
                    'expensable_id': null,
                    'expensable_type': 'App\\Proposal',
                    'frequency': 'PSF',
                    'type_id': '',
                    'amount_in_dollars': '',
                    'base_net_included': ''
                },
                loading: false,
                isReady: false
            }
        },

        mounted() {
            this.expense.expensable_id = this.proposals.selectedProposalId;

            axios.get('/api/expense-types').then((response) => {
                this.expenseTypes = response.data;
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: 'Error',
                    text: 'Error pulling Expense Types, please try again later'
                });
            });
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['selectedProposal']),

            errors() {
                return this.proposals.errors;
            },

            expenseTypeOptions() {
                return [
                    { value: '', label: 'Select type' },
                    ...Object.values(this.expenseTypes).map(type => ({
                        value: type.id,
                        label: type.name
                    }))
                ];
            },

            baseNetOptions() {
                return [
                    { value: '', label: 'Select option' },
                    { value: 'Base', label: 'Base' },
                    { value: 'Net', label: 'Net' },
                    { value: 'Included', label: 'Included' }
                ];
            },

            formFields() {
                return [
                    {
                        name: 'type_id',
                        label: 'Type',
                        type: 'select',
                        required: true,
                        options: this.expenseTypeOptions,
                    },
                    {
                        name: 'amount_in_dollars',
                        label: 'Amount PSF',
                        type: 'currency',
                        required: true,
                        componentProps: {
                            size: 11,
                            isDecimal: true
                        }
                    },
                    {
                        name: 'base_net_included',
                        label: 'Base or Net',
                        type: 'select',
                        required: true,
                        options: this.baseNetOptions,
                    }
                ];
            }
        },

        methods: {
            handleModalOpened() {
                // Use nextTick to ensure expense data is fully ready before rendering form
                this.$nextTick(() => {
                    this.isReady = true;
                });
            },

            async createExpense() {
                this.loading = true;

                await this.$store.dispatch('createProposalExpense', this.expense).then(() => {
                    this.loading = false;
                    
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: "Expense Saved"
                    });

                    this.$emit('save-proposal');

                    this.$modal.hide('new-proposal-expense');
                }).catch(() => {
                    this.loading = false;
                });
            },

            resetForm() {
                this.isReady = false;
                this.expense = {
                    'expensable_id': this.proposals.selectedProposalId,
                    'expensable_type': 'App\\Proposal',
                    'frequency': 'PSF',
                    'type_id': '',
                    'amount_in_dollars': '',
                    'base_net_included': ''
                };
            }
        }
    }
</script>
